import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const piErrorMessage = (err, fallback = 'Something went wrong') => {
  const d = err?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  return d.message || fallback;
};

export const resubmitPi = async (piId) => {
  const r = await axios.post(`${API}/proforma-invoices/${piId}/resubmit`);
  return r.data;
};
